/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import DefaultQueue from './default.queue';
import PriorityQueue from './priority.queue';
import ZoneInfluenceQueue from './zone.influence.queue';


export default class
{
  constructor (parent)
  {
    const setupCallback = (object) => object.setup();
    const installCallback = (object) => object.install();

    this.entityInteractionQueue = new PriorityQueue(parent);

    this.sectorInfluenceQueue = new DefaultQueue(installCallback);
    this.sectorStatusQueue = new DefaultQueue(installCallback);

    this.zoneSetupQueue = new DefaultQueue(setupCallback);
    this.zoneInstallQueue = new DefaultQueue(installCallback);

    this.zoneInfluenceQueue = new ZoneInfluenceQueue(parent);
  }


  execute ()
  {
    this.entityInteractionQueue.execute();

    this.zoneSetupQueue.execute();
    this.sectorInfluenceQueue.execute();
    this.zoneInstallQueue.execute();
    this.sectorStatusQueue.execute();

    this.zoneInfluenceQueue.execute();
  }


  getEntityInteractionQueue ()
  {
    return this.entityInteractionQueue;
  }


  getSectorInfluenceQueue ()
  {
    return this.sectorInfluenceQueue;
  }


  getSectorStatusQueue ()
  {
    return this.sectorStatusQueue;
  }


  getZoneSetupQueue ()
  {
    return this.zoneSetupQueue;
  }


  getZoneInstallQueue ()
  {
    return this.zoneInstallQueue;
  }


  getZoneInfluenceQueue ()
  {
    return this.zoneInfluenceQueue;
  }


};
